/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { BackfillStatusResponse } from "../models/index";
import {
  BackfillStatusResponseFromJSON,
  BackfillStatusResponseToJSON,
} from "../models/index";

/**
 *
 */
export class BackfillsApi extends runtime.BaseAPI {
  /**
   * Every known backfill with its current status, plus the recent run history.
   * Every known backfill with its current status, plus the recent run history.
   */
  async getBackfillsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BackfillStatusResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/backfills`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BackfillStatusResponseFromJSON(jsonValue),
    );
  }

  /**
   * Every known backfill with its current status, plus the recent run history.
   * Every known backfill with its current status, plus the recent run history.
   */
  async getBackfills(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BackfillStatusResponse> {
    const response = await this.getBackfillsRaw(initOverrides);
    return await response.value();
  }
}
